import React from 'react';
import { useTranslation } from 'react-i18next';
import './powering.css';

const Powering = () => {
    const { t } = useTranslation();

    const cards = [
        { code: 'FR', title: t('frontendTitle'), text: t('frontendText'), bullets: t('frontendBullets', { returnObjects: true }) },
        { code: 'BA', title: t('backendTitle'), text: t('backendText'), bullets: t('backendBullets', { returnObjects: true }) },
        { code: 'UX', title: t('uiuxTitle'), text: t('uiuxText'), bullets: t('uiuxBullets', { returnObjects: true }) },
        { code: 'AI', title: t('aiTitle'), text: t('aiText'), bullets: t('aiBullets', { returnObjects: true }) },
        { code: 'MA', title: t('mobileTitle'), text: t('mobileText'), bullets: t('mobileBullets', { returnObjects: true }) },
    ];

    return (
        <section aria-label={t('poweringProjects')} className="powering-section">
            <h2 className="section__title">{t('poweringProjects')}</h2>

            <div className="stack-container">
                {cards.map((card, i) => (
                    <div
                        key={i}
                        className={`stack-card stack-card--${i + 1}`}
                        style={{
                            top: `calc(clamp(6vh, 10vh, 12vh) + ${i * 18}px)`,
                            zIndex: i + 1,
                        }}
                    >
                        <div className="stack-card__inner">
                            <div className="stack-card__top">
                                <span className="stack-card__counter">
                                    {String(i + 1).padStart(2, '0')} / {String(cards.length).padStart(2, '0')}
                                </span>
                                <div className="stack-card__code">{card.code}</div>
                            </div>

                            <h3 className="stack-card__title">{card.title}</h3>
                            <p className="stack-card__text">{card.text}</p>

                            <ul className="stack-card__bullets">
                                {card.bullets.map((bullet, bi) => (
                                    <li key={bi} className="stack-card__bullet">
                                        {bullet}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Powering;